module.exports = __webpack_public_path__ + "img/psd.9e87b997.svg";